export default "__VITE_ASSET__BMpzPAv9__"